import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  getFirestore,
  query,
  setDoc,
  where,
} from 'firebase/firestore';
import { firebaseApp } from './config';
import { LogType } from '../interfaces/LogType';
import { getCurrentUserId } from './auth-helper';
import { SettingsType, UserType } from '../interfaces/SettingsType';

const db = getFirestore(firebaseApp);

export function createSettingsItem(data: any) {
  console.log(data);
  const item: SettingsType = {
    isAdmin: data.isAdmin ? data.isAdmin : false,
    isSuperAdmin: data.isSuperAdmin ? data.isSuperAdmin : false,
    userList: data.userList ? data.userList : [],
    sharedWithList: data.sharedWithList ? data.sharedWithList : [],
    zugangscode: data.zugangscode
      ? data.zugangscode
      : 'Kein Zugangscode hinterlegt',
    prename: data.prename ? data.prename : '',
    lastname: data.lastname ? data.lastname : '',
    profileImg: data.profileImg ? data.profileImg : '',
  };
  return item;
}
export async function loadSettings(): Promise<SettingsType | undefined> {
  console.log('loadSettings');
  const uid = getCurrentUserId();
  if (uid == undefined) {
    return undefined;
  }
  const q = query(collection(db, 'users', uid, 'settings'));
  const querySnapshot = await getDocs(q);
  let result = undefined;
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    result = createSettingsItem(data);
  });
  if (result == undefined) return createSettingsItem({});
  return result;
}
export async function loadSharedUsers(
  settings: SettingsType
): Promise<UserType[] | undefined> {
  console.log('loadSharedUsers');
  const uid = getCurrentUserId();
  if (uid == undefined) {
    return undefined;
  }

  let zugriffscode: string | undefined = undefined;
  if (settings == undefined) {
    return [];
  } else {
    const zugangscode = settings.zugangscode;
    if (settings.zugangscode != createSettingsItem({}).zugangscode) {
      console.log('Zugriffscode gefunden');
      zugriffscode = zugangscode;
    }
  }
  const q = query(
    collection(db, 'users', zugriffscode ? zugriffscode : uid, 'settings')
  );
  const querySnapshot = await getDocs(q);
  let result: SettingsType | undefined;
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    result = createSettingsItem(data);
  });
  return result?.userList;
}

export async function saveSettings(settings: SettingsType) {
  console.log('saveSettings');
  const uid = getCurrentUserId();
  if (uid == undefined) {
    return;
  }
  const ref = doc(db, 'users', uid, 'settings', 'general');
  setDoc(ref, settings);
}
